import cl from "clsx";
export const typoClassNames = (props) => {
    return cl({
        "navds-typo--spacing": props.spacing,
        "navds-typo--truncate": props.truncate,
        "navds-typo--semibold": props.weight === "semibold",
        [`navds-typo--align-${props.align}`]: props.align,
        [`navds-typo--color-${props.textColor}`]: props.textColor,
        "navds-typo--visually-hidden": props.visuallyHidden,
        "navds-typo--uppercase": props.uppercase,
    });
};
//# sourceMappingURL=util.js.map